module.exports = __webpack_public_path__ + "a998aafcce3e1fc0f21be46eccadf404.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/collosal_battles-320.webp.png
// module id = 213
// module chunks = 0